// Map an E.164 destination number to a country name (longest-prefix match).
// USA and Canada share +1: Canadian area codes (NPAs) map to Canada, the rest of +1 to USA.
// Covers common destinations; unmapped numbers fall back to "Intl (+<code>)".
export const CANADA_NPAS = [
  '204','226','236','249','250','257','263','289','306','343','354','365','367','368','382','387','403','416','418','428',
  '431','437','438','450','460','468','474','506','514','519','548','579','581','584','587','604','613','639','647','672',
  '683','705','709','742','753','778','780','782','807','819','825','867','873','879','902','905',
];
const CC: Record<string, string> = {
  '1': 'USA', '44': 'United Kingdom', '353': 'Ireland',
  '92': 'Pakistan', '91': 'India', '880': 'Bangladesh', '94': 'Sri Lanka', '977': 'Nepal', '93': 'Afghanistan', '95': 'Myanmar',
  '971': 'UAE', '966': 'Saudi Arabia', '974': 'Qatar', '973': 'Bahrain', '965': 'Kuwait', '968': 'Oman',
  '961': 'Lebanon', '962': 'Jordan', '963': 'Syria', '964': 'Iraq', '967': 'Yemen', '970': 'Palestine', '972': 'Israel', '98': 'Iran',
  '20': 'Egypt', '212': 'Morocco', '213': 'Algeria', '216': 'Tunisia', '218': 'Libya', '249': 'Sudan',
  '234': 'Nigeria', '254': 'Kenya', '27': 'South Africa', '251': 'Ethiopia', '233': 'Ghana', '256': 'Uganda', '255': 'Tanzania',
  '90': 'Turkey', '7': 'Russia / Kazakhstan', '380': 'Ukraine',
  '86': 'China', '81': 'Japan', '82': 'South Korea', '84': 'Vietnam', '66': 'Thailand', '62': 'Indonesia',
  '60': 'Malaysia', '63': 'Philippines', '65': 'Singapore', '852': 'Hong Kong', '853': 'Macao', '886': 'Taiwan', '855': 'Cambodia',
  '49': 'Germany', '33': 'France', '34': 'Spain', '39': 'Italy', '31': 'Netherlands', '32': 'Belgium', '41': 'Switzerland',
  '43': 'Austria', '351': 'Portugal', '30': 'Greece', '46': 'Sweden', '47': 'Norway', '45': 'Denmark', '358': 'Finland',
  '48': 'Poland', '40': 'Romania', '420': 'Czechia', '36': 'Hungary', '359': 'Bulgaria', '385': 'Croatia', '381': 'Serbia',
  '61': 'Australia', '64': 'New Zealand',
  '52': 'Mexico', '55': 'Brazil', '54': 'Argentina', '57': 'Colombia', '56': 'Chile', '51': 'Peru', '58': 'Venezuela', '593': 'Ecuador',
};
for (const npa of CANADA_NPAS) CC['1' + npa] = 'Canada';
const CODES = Object.keys(CC).sort((a, b) => b.length - a.length);

// For dropdowns: [{ code:'44', name:'United Kingdom' }, …] sorted by name.
// '1' = USA (Canada excluded server-side); 'CA' = Canada (Canadian area codes).
export const COUNTRY_LIST: { code: string; name: string }[] =
  Object.entries(CC).filter(([code]) => !(code.length === 4 && code.startsWith('1')))
    .map(([code, name]) => ({ code, name }))
    .concat([{ code: 'CA', name: 'Canada' }])
    .sort((a, b) => a.name.localeCompare(b.name));

export function countryOf(num?: string | null): string {
  if (!num) return 'Unknown';
  let d = String(num).replace(/[^0-9]/g, '');
  if (d.startsWith('011')) d = d.slice(3);       // US intl prefix
  else if (d.startsWith('00')) d = d.slice(2);   // EU intl prefix
  if (!d) return 'Unknown';
  for (const c of CODES) if (d.startsWith(c)) return CC[c];
  return 'Intl (+' + d.slice(0, Math.min(3, d.length)) + ')';
}
